import { useContext } from 'react'
import { SuccessIcon } from '../../assets/images/icons'
import { GlobalContext } from '../../contexts/Global'
import * as S from './style'

const ThankYouPage = () => {
  const {
    state: { showThankYouPageFields, isAlternativeActive },
  } = useContext(GlobalContext)

  const supportLink =
    window.location.href.indexOf('maggiortutela') > -1
      ? process.env.REACT_APP_LINK_MERCATO_TUTELATO
      : process.env.REACT_APP_LINK_MERCATO_LIBERO

  return (
    <S.ThankYouPageWrapper isAlternativeActive={isAlternativeActive}>
      <S.ThankYouPageIconContainer>
        <SuccessIcon />
      </S.ThankYouPageIconContainer>
      <S.ThankYouPageTitleContainer>
        {showThankYouPageFields.type === 'resetPassword' ? (
          <>
            Se l'indirizzo e-mail o il nome utente inseriti corrispondono ad un
            utente registrato, <br /> riceverai una e-mail con le indicazioni
            per reimpostare la password.
          </>
        ) : (
          <>
            Se l'indirizzo e-mail o il nome utente inseriti corrispondono ad un
            utente registrato, <br /> riceverai una e-mail con le indicazioni
            per reimpostare la password.
          </>
        )}
      </S.ThankYouPageTitleContainer>
      <S.ThankYouPageSubtitleContainer>
        <strong>
          Se non hai ricevuto la e-mail, verifica che i dati inseriti siano
          corretti.
        </strong>
      </S.ThankYouPageSubtitleContainer>
    </S.ThankYouPageWrapper>
  )
}

export default ThankYouPage
